import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import ReactTooltip from 'react-tooltip';

import { buildPatientProfilePicUrl } from '../../../../../lib/util';
import { Button } from '../../../../../components';

const ProfilePic = ({ patient = {}, isDependentEvisit = false, isTAV = false, isClosed = false, isPatientConnected = false, onReinvitePatient }) => {
	return (
		<div className="profile-pic">
			{isDependentEvisit ? (
				<div className="thumb48 bg-info img-rounded dependent-icon">
					<em className="fa fa-child fa-inverse fa-3x"></em>
				</div>
			) : (
				<React.Fragment>
					<div className="user-block-status">
						<img
							src={buildPatientProfilePicUrl(patient)}
							alt="Avatar"
							className="thumb96 img-rounded"
						/>
						{(isTAV && !isClosed) && (
							<div className={cn('status', { 'bg-success': isPatientConnected, 'bg-danger': !isPatientConnected }, 'text-center')}>
								<a
									href="#"
									style={{ textDecoration: 'underline dotted', display: 'inline-block', color: 'white' }}
									className="patient-activity"
									data-tip
									data-for="patient-activity"
								>{isPatientConnected ? (
									<React.Fragment>ACTIVE</React.Fragment>
								) : (
									<React.Fragment>INACTIVE</React.Fragment>
								)}</a>
								<ReactTooltip place="right" type="light" effect="solid" id="patient-activity">
									<div>
										{isPatientConnected ? 'Patient is available in visit waiting room' : 'Patient is not currently in the visit waiting room. You may not get a response in a timely manner until they return.'}
									</div>
								</ReactTooltip>
							</div>
						)}
					</div>
					{(isTAV && !isClosed && !isPatientConnected) && (
						<div className="mt">
							<Button
								title="Reinvite Patient"
								danger
								small
								onClick={onReinvitePatient}
								className="evisit-reinvite"
							/>
						</div>
					)}
				</React.Fragment>
			)}
		</div>
	);
};

ProfilePic.propTypes = {
	patient: PropTypes.object,
	isDependentEvisit: PropTypes.bool,
	isTAV: PropTypes.bool,
	isClosed: PropTypes.bool,
	isPatientConnected: PropTypes.bool,
	onReinvitePatient: PropTypes.func.isRequired,
};

export default ProfilePic;
